import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { retry, take } from 'rxjs/operators';
import { CcAdminApiHelperService } from '../ccAdmin/cc-admin-api-helper.service';
import { onlyTruthy } from 'src/app/utils/rxjs-custom-operators/rxjs-custom-operators.utils';

@Injectable({
	providedIn: 'root',
})
export class TokenInjectionService implements HttpInterceptor {
	private initialized = false;

	constructor(private ccAdminApiHelperService: CcAdminApiHelperService) {
		// Once the token is ready, allow API calls to proceed
		this.ccAdminApiHelperService.tokenReady.pipe(onlyTruthy(), take(1)).subscribe(() => {
			this.initialized = true;
		});
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		// Add the Authorization Bearer token to Header of all backend requests
		if (req.url.startsWith(env.manageApiUrl)) {
			// Block any API calls before initialization has completed
			if (!this.initialized && !req.url.startsWith(`${env.manageApiUrl}/initialize`)) {
				if (!req.url.endsWith('frontend/logs')) {
					console.error(`Attempted to make a request to ${req.url} but token was not ready`);
				}
				return EMPTY;
			}
			// Attach token to request
			const token = this.ccAdminApiHelperService.getToken();
			let newHeaders = req.headers;
			if (token) {
				newHeaders = req.headers.append('Authorization', `Bearer ${token}`);
			}
			const authReq = req.clone({ headers: newHeaders });
			return this.injectSecurityHeaders(authReq, next);
		}
		return next.handle(req).pipe(retry(3));
	}

	// Add the security minded headers to Header of all orchestrate api backend requests
	private injectSecurityHeaders(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let newHeaders = req.headers.append('Strict-Transport-Security', 'max-age=31536000; includeSubDomains');
		newHeaders = newHeaders.append('X-Frame-Options', 'DENY');
		newHeaders = newHeaders.append('X-Content-Type-Options', 'nosniff');
		newHeaders = newHeaders.append('Content-Security-Policy', 'upgrade-insecure-requests');
		const secureHeaderReq = req.clone({
			headers: newHeaders,
		});
		return next.handle(secureHeaderReq);
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
